module.exports = __webpack_public_path__ + "static/assets/e3224388bbaa7249cec9c5d12ff7257a.png";